export default {"src":"/_next/static/media/ooo.79f4a575.svg","height":513,"width":513};